<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('form_label_check_detail') || '盘点单详情'"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div class="ml-4 mr-4">
        <el-form
          class="mt-2"
          ref="form"
          :model="formData"
          :disabled="disabled"
          :rules="rules"
          label-width="100px"
          label-position="left"
        >
          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item
                  :label="$l('form_label_amz_fty_check_no') || '盘点单号'"
                >
                  <div>{{ formData.amzFtyCheckNo }}</div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item
                  :label="$l('form_label_inventory_time') || '盘点时间'"
                  prop="fabricCategoryCode"
                >
                  <div>{{ formData.createDate }}</div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item
                  :label="$l('INDEX.table_label_factory') || '成品工厂'"
                  prop="scmCode"
                >
                  <dict-select
                    v-model="formData.scmCode"
                    url="/master/common/dict/scmPartners"
                    clearable
                    filterable
                    style="width:100%"
                    size="mini"
                  ></dict-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item
                  :label="$l('form_bill_in_date') || '入库日期'"
                  prop="inboundDate"
                >
                  <el-date-picker
                    v-model="formData.inboundDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                    size="mini"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item
                  :label="$l('form_label_location_no') || '库位编号'"
                  prop="locationNo"
                >
                  <el-input
                    v-model.trim="formData.locationNo"
                    clearable
                    size="mini"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item :label="$l('form_label_checked_by') || '盘点人'">
                  <div>{{ formData.createByName }}</div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item
                  :label="$l('form_label_modify_date') || '更新时间'"
                >
                  <div>{{ formData.modifyDate }}</div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item :label="$l('form_label_modify_by') || '更新人'">
                  <div>{{ formData.modifyByName }}</div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <UpdateFtyCheckDetail
          ref="itemTable"
          class="mt-2"
          :amzFtyCheckCode="amzFtyCheckCode"
          :amzFtyCheckTaskCode="amzFtyCheckTaskCode"
          :disabled="disabled"
        />

        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            v-if="!disabled"
            @click="save()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import UpdateFtyCheckDetail from './update-fty-check-detail'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'

export default {
  mixins: [EditLoading],
  components: { UpdateFtyCheckDetail },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzFtyCheckTaskCode: { type: String, default: '' },
    amzFtyCheckCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        scmCode: [
          {
            required: true,
            message: ' ',
            trigger: 'change',
          },
        ],
        inboundDate: [
          {
            required: true,
            message: ' ',
            trigger: 'change',
          },
        ],
        locationNo: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      setTimeout(() => {}, 2000)
      this.loadingOpen()
      this.$api
        .ecomAmzFtyCheckDetailApi({
          amzFtyCheckCode: this.amzFtyCheckCode,
        })
        .then((res) => {
          this.loadingClose()
          this.formData = res.body
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const detailUpdateList = this.$refs.itemTable.getTableData()
      if (!detailUpdateList || detailUpdateList.length < 1) {
        this.$message.warning('盘点明细列表不能为空')
        return
      }
      const detailDelList = this.$refs.itemTable.getDelTableData()
      this.loadingOpen()
      this.$api
        .ecomAmzFtyCheckUpdateSaveApi({
          ...this.formData,
          detailUpdateList,
          detailDelList,
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.close()
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },

    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 10px 12px;
}

::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    .el-row {
      .el-col {
        > div:first-child {
          border-top: 1px solid #ebeef5;
        }
        > div {
          border: 1px solid #ebeef5;
          border-top: none;

          > .el-form-item {
            margin: 0 !important;
            position: relative;

            .el-form-item__label {
              color: #909399;
              background: #fafafa;
              box-sizing: border-box;
              text-align: left;
              font-weight: 400;
              line-height: 1.5;
              padding: 8px 10px;
              border-right: 1px solid #ebeef5;
              font-size: 12px !important;
              position: absolute;
              bottom: 0;
              top: 0;
              display: flex;
              align-items: center;
            }

            .el-form-item__content {
              padding: 0 10px;
              box-sizing: border-box;
              text-align: left;
              font-weight: 400;
              line-height: 1.5;
              color: #606266;
              font-size: 12px !important;

              > div {
                margin: 3.2px 0;
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
